import React from 'react'
import { useInlineSettings } from '../TaskCreation/contexts/InlineSettingsContext'
import { Surface, SurfaceProps } from 'components/ui/Surface'
import { useBuilderWidget } from '../TaskCreation/contexts/BuilderWidgetContext'

export const WidgetWrapper: React.FC<SurfaceProps> = (props) => {
  const isBuilder = useBuilderWidget()
  const inlineSettings = useInlineSettings()

  return (
    <Surface
      {...(isBuilder ? { borderRadius: 0, boxShadow: 'none' } : {})}
      {...props}
      {...(inlineSettings
        ? {
            boxShadow: 'none',
            border: '1px solid',
            borderColor: props.isError ? '#EA9999' : '#E2E8F0',
            borderRadius: '10px',
          }
        : {})}
      {...(isBuilder ? { padding: 0 } : {})}
    />
  )
}
